import styled from '@emotion/styled';
import { Flex } from '.';
import { shouldForwardProps } from '../../helpers';
import { theme } from '../../design-system';

const StyledCard = ({ selected, disabled, ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);

  const getColorsByVariant = (selected) => {
    const variants = {
      selected: {
        backgroundColor: theme.colors.callToAction,
        border: `2px solid ${theme.colors.callToAction}`,
        color: '#fff',
      },
      default: {
        border: `2px solid ${theme.colors.secondary}`,
        color: theme.colors.secondary,
      },
    };

    return selected ? variants['selected'] : variants['default'];
  };

  const disabledStyles = {
    border: `2px solid ${theme.colors.neutralLight}`,
    color: theme.colors.neutralLight,
  };

  const colorsByVariant = disabled ? disabledStyles : getColorsByVariant(selected);

  return {
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '10px 30px',
    ...customPropsObj,
    ...colorsByVariant,
    ...(disabled && { pointerEvents: 'none' }),
  };
};

export const SelectionCard = ({ children, ...props }) => {
  const CardElement = styled(Flex)(StyledCard);

  return <CardElement {...props}>{children}</CardElement>;
};
